import React from 'react';
import { Menu, Avatar, MenuItem, Typography } from '@mui/material';
import { MdLogout, MdSwapHoriz  } from 'react-icons/md';
import { User } from "oidc-client-ts";
import { UserNameCard, OrganizationNameCard, UserInfoCardContainer } from './Header.styled';

interface UserMenuProps {
    anchorElUser: Element | null;
    handleCloseUserMenu: () => void;
    userInfo: User | null
    actorName: string | undefined;
    logOut: () => void;
    switchUser: () => void;
}

/**
 * `UserMenu` is a React functional component that renders a user profile menu using Material-UI components.
 * It takes in props such as `anchorElUser` for positioning, `handleCloseUserMenu` for closing the menu,
 * `userInfo` containing user details, `logOut` to handle the logout process and `SwitchUser` to handle switch user process. 
 * The menu displays the user's initial from their name as an avatar and shows the user's full name and organization name if available.
 */
const UserMenu: React.FC<UserMenuProps> = ({ anchorElUser, handleCloseUserMenu, userInfo, actorName, logOut, switchUser }) => {
    return (
        <Menu
            sx={{ mt: 1 }}
            PaperProps={{ sx: { width: 300, maxWidth: 'calc(100vw - 32px)' } }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
        >
            <UserInfoCardContainer>
                <Avatar sx={{ mx: 'auto', width: 48, height: 48, bgcolor: 'primary.light', color: 'primary.main', mb: 2 }}>
                    {userInfo?.profile?.name?.charAt(0) ? userInfo?.profile?.name?.charAt(0) : 'N'}
                </Avatar>
                <OrganizationNameCard>{userInfo?.profile?.name}</OrganizationNameCard>
                {actorName && <UserNameCard>{actorName}</UserNameCard>}
            </UserInfoCardContainer>
            <MenuItem onClick={switchUser} sx={{ borderTop: '1px solid', borderColor: 'divider', py: 1.5 }}>
                <MdSwapHoriz style={{ marginRight: '10px'}} />
                <Typography textAlign="center">Skipta um umboð</Typography>
            </MenuItem>
            <MenuItem onClick={logOut} sx={{ py: 1.5 }}>
                <MdLogout style={{ marginRight: '10px' }} />
                <Typography textAlign="center">Skrá út</Typography>
            </MenuItem>
        </Menu>
    );
}

export default UserMenu;
